export default __webpack_public_path__ + "static/media/aqua_black.a5bf3189.png";